import { observable } from 'mobx';

export class TriageAlertState {
    @observable public visible: boolean = false;
    @observable public shouldShowSignInButton: boolean = false;
}
